import { render, staticRenderFns } from "./ProducerDetails.vue?vue&type=template&id=e15d3c84&scoped=true&"
import script from "./ProducerDetails.vue?vue&type=script&lang=js&"
export * from "./ProducerDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e15d3c84",
  null
  
)

export default component.exports